import { ACTION_DEFINITIONS } from './actions';
import { FUNCTION_DEFINITIONS } from './functions';

// Export constants
export * from './constants';

// Export action and function definitions for advanced use
/**
 * Get all copilot actions for a specific domain
 * @param {string} domain - Domain identifier (e.g., 'ssm')
 * @returns {Object} Object containing all actions for the domain
 */
export const getCopilotActions = (domain) => {
    if (!domain) {
        console.warn('getCopilotActions: domain parameter is required');
        return {};
    }

    const domainActions = ACTION_DEFINITIONS[domain];
    if (!domainActions) {
        console.warn(`getCopilotActions: Unknown domain '${domain}'`);
        return {};
    }

    return { ...domainActions };
};

/**
 * Get all copilot functions (global, not domain-specific)
 * @returns {Object} Object containing all copilot functions
 */
export const getCopilotFunctions = () => {
    return { ...FUNCTION_DEFINITIONS };
};
